/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_PrefixInputs */

const en_error_prefix = /** @type {(inputs: Error_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred:`)
};

const de_error_prefix = /** @type {(inputs: Error_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Fehler ist aufgetreten:`)
};

/**
* | output |
* | --- |
* | "An error occurred:" |
*
* @param {Error_PrefixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const error_prefix = /** @type {((inputs?: Error_PrefixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_PrefixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_error_prefix(inputs)
	return en_error_prefix(inputs)
});